import { Box } from '@mui/material';
import React from 'react';
import CAppFilterSelect from '../../../../../../../app/components/CAppFilterSelect';
import IFund from '../../../../../interfaces/fund/IFund';
import IInvestExpertiseFilters from '../../../../../interfaces/expertise/IInvestExpertiseFilters';
import { useTranslation } from 'react-i18next';
type CFiltersPlacementDurationSelectProps = {
	optionsPlacementDurations: { id: string; name: string }[];
	filters: IInvestExpertiseFilters;
	onChange: (filters: IInvestExpertiseFilters) => void;
	label: string;
	multipleRenderLabelLangTag: string;
};

const CFiltersPlacementDurationSelect = (props: CFiltersPlacementDurationSelectProps) => {
	const { optionsPlacementDurations, filters, onChange, label, multipleRenderLabelLangTag } = props;

	const { t } = useTranslation();

	return (
		<>
			{optionsPlacementDurations ? (
				<CAppFilterSelect
					className="filter-placement-duration"
					multiple
					multipleRenderTags={(val: IFund[]) => (
						<Box style={{ paddingLeft: '5px', fontSize: '0.85rem' }}>
							{t(multipleRenderLabelLangTag, { count: val ? val.length : 0 })}
						</Box>
					)}
					value={
						filters?.placementDurations
							? optionsPlacementDurations.filter((x) => filters.placementDurations?.includes(x.id))
							: null
					}
					onChange={(val: { id: string; name: string }[]) =>
						onChange({
							...filters,
							placementDurations: val?.map((x) => x.id) ?? [],
						})
					}
					label={label}
					size="small"
					options={optionsPlacementDurations}
				/>
			) : (
				<></>
			)}
		</>
	);
};

export default CFiltersPlacementDurationSelect;
